import React from 'react';
import styled from 'styled-components';

import {
  FormGroup,
  FormRadio,
  Type,
} from '@spotify-internal/encore-creator-web';
import { gray50 } from '@spotify-internal/encore-foundation';

import { DialogBodyProps } from '../../../types';

const RadioDisclaimer = styled(Type).attrs({
  forwardedAs: 'p',
  variant: Type.body4,
  color: gray50,
})`
  font-size: 14px;
  line-height: 20px;
  padding-left: 28px;
`;

const Span16 = styled.span`
  font-size: 16px;
  line-height: 24px;
`;

const options = {
  cashapp: {
    type: 'text',
    displayName: 'Cash App',
  },
  gofundme: {
    type: 'text',
    displayName: 'GoFundMe',
  },
  paypal: {
    type: 'text',
    displayName: 'PayPal',
  },
  musicrelieforg: {
    type: 'select',
    displayName: 'Music Relief organization',
  },
} as const;

// DEPRECATEDRadio before new markets rolled out
// TODO: delete 4 weeks after rollout to 100%
export function DEPRECATEDRadioGroup(props: DialogBodyProps) {
  function onProviderChange(ev: React.ChangeEvent<HTMLInputElement>) {
    const nextProvider = ev.target.value;
    props.link.reset();
    props.org.reset();
    props.provider.setValue(ev);
    if (nextProvider === 'paypal') {
      props.link.setPrefix('https://www.paypal.me/');
    } else if (nextProvider === 'gofundme') {
      props.link.setPrefix('https://www.gofundme.com/f/');
    } else if (nextProvider === 'cashapp') {
      props.link.setPrefix('https://cash.app/$');
    }
  }

  const radioGroupLabel = props.isEditing
    ? 'Edit your Artist Fundraising Pick'
    : 'Set your Artist Fundraising Pick';

  return (
    <FormGroup
      role="radiogroup"
      aria-label={radioGroupLabel}
      style={{ paddingBottom: '40px' }}
    >
      {Object.keys(options).map(key => {
        // @ts-ignore
        const option = options[key];

        const formRadioId = `fundraising-pick-type-${key}`;

        const checked = key === props.provider.value;

        const isPaypal = key === 'paypal';

        const hasDisclaimer = checked && isPaypal;

        return (
          <React.Fragment key={key}>
            <FormRadio
              id={formRadioId}
              name="fundraising-pick-type"
              value={key}
              onChange={onProviderChange}
              checked={checked}
              aria-checked={checked}
              aria-describedby={hasDisclaimer ? `${key}-disclaimer` : undefined}
            >
              <Span16>{option.displayName}</Span16>
            </FormRadio>
            {hasDisclaimer ? (
              <RadioDisclaimer id={`${key}-disclaimer`}>
                If you're based in one of these countries, don't use PayPal.Me
                for your Artist Fundraising Pick or it will be removed and
                PayPal may impose restrictions and limitations on your PayPal
                account: AE, AR, BH, BR, CL, CO, CR, DO, EC, GT, HK, HN, IN, IL,
                JO, MX, MY, NI, OM, PA, PE, QA, SA, SG, SV, UY.
              </RadioDisclaimer>
            ) : null}
          </React.Fragment>
        );
      })}
    </FormGroup>
  );
}
